import { graphql } from "@opensea/graphql"
import { PreviewImagesFragment } from "../PreviewImages"

export const MintModuleFragment = graphql(
  `
    fragment MintModule on Collection {
      __typename
      ... on Collection {
        ...PreviewImages
        name
        slug
        about {
          previewMedia {
            __typename
          }
        }
      }
    }
  `,
  [PreviewImagesFragment],
)
